'use client';

import React from 'react';
import type { WaitlistWidgetTemplate } from '@/features/widget-setup/types';
import { getWaitlistTemplateDefinition } from '@/lib/widgets/waitlist/templateRegistry';
import {
    CardTemplate,
    CenteredTemplate,
    DarkPremiumTemplate,
    LaunchCardTemplate,
    MinimalTemplate,
    SocialProofTemplate,
    SplitTemplate,
    WidgetFormTemplateProps,
} from './WidgetFormTemplates';

export type WidgetPreviewDevice = 'desktop' | 'tablet' | 'mobile';

const PREVIEW_WIDTHS: Record<'narrow' | 'wide', Record<WidgetPreviewDevice, string>> = {
    narrow: {
        desktop: 'max-w-[520px] w-full',
        tablet: 'max-w-[460px] w-full',
        mobile: 'max-w-[340px] w-full',
    },
    wide: {
        desktop: 'max-w-[780px] w-full',
        tablet: 'max-w-[620px] w-full',
        mobile: 'max-w-[340px] w-full',
    },
};

export function getWidgetPreviewWidthClass(template: WaitlistWidgetTemplate, device: WidgetPreviewDevice) {
    const definition = getWaitlistTemplateDefinition(template);
    return PREVIEW_WIDTHS[definition.width][device];
}

export function WidgetTemplatePreview({
    template,
    props,
}: {
    template: WaitlistWidgetTemplate;
    props: WidgetFormTemplateProps;
}) {
    switch (template) {
        case 'minimal':
            return <MinimalTemplate {...props} />;
        case 'card':
            return <CardTemplate {...props} />;
        case 'split':
            return <SplitTemplate {...props} />;
        case 'launch_card':
            return <LaunchCardTemplate {...props} />;
        case 'dark_premium':
            return <DarkPremiumTemplate {...props} />;
        case 'social_proof':
            return <SocialProofTemplate {...props} />;
        case 'centered':
        default:
            return <CenteredTemplate {...props} />;
    }
}

